export const EventRoutes = {
	Events: '/events',
};
